export default "__VITE_PUBLIC_ASSET__868aabbd__"